import React from 'react';
import { Layout } from 'antd';

const { Footer } = Layout;

const AppFooter = () => (
    <Footer style={{ textAlign: 'center', backgroundColor: "white" }}>
        ©2024 office@homeprimeservices.com. All Rights Reserved.
    </Footer>
);

export default AppFooter;
